import { firestoreAction } from 'vuexfire';

import adminApi from '../../firebase/admin';
import { canUpdate } from '../plugins';
import { db } from '../../firebase';
import PluggableModule from '../pluggable';
import { startsWithQuery } from '../../firebase/utils';

const admin = new PluggableModule('admin', 'admin');
admin.addMutationTypes([
  'ADMIN_LOADING_INIT',
  'ADMIN_LOADING_DONE',
  'ADMIN_LOADING_ERROR',
  'ADMIN_ROLES_DONE'
]);

admin.extend({
  namespaced: true,
  state: {
    roles: [],
    users: [],
    loading: false,
    loadError: false
  },
  mutations: {
    [admin.con.ADMIN_LOADING_INIT](state) {
      state.loading = true;
    },
    [admin.con.ADMIN_LOADING_DONE](state) {
      state.loading = false;
    },
    [admin.con.ADMIN_LOADING_ERROR](state, error) {
      state.loading = false;
      state.loadError = error;
    },
    [admin.con.ADMIN_ROLES_DONE](state, roles) {
      state.roles = roles;
    }
  },
  actions: {
    async assignRoles({ commit }, data) {
      commit(admin.con.ADMIN_SUBMIT_INIT);
      try {
        await adminApi.assignRoles(data.userId, data.roles);
        commit(admin.con.ADMIN_SUBMIT_DONE);
      } catch (error) {
        commit(admin.con.ADMIN_SUBMIT_DONE);
        throw error;
      }
    },
    async getRoles({ commit }) {
      const roles = await adminApi.getRoles();
      commit(admin.con.ADMIN_ROLES_DONE, roles);
    },
    getAdminUsers: firestoreAction(
      async ({ bindFirestoreRef, commit, dispatch }) => {
        commit(admin.con.LOADING_INIT, null, { root: true });
        commit(admin.con.ADMIN_LOADING_INIT);
        try {
          const ref = db.collection('users').where('rolesCount', '>', 0);
          await bindFirestoreRef('users', ref);
          await dispatch('getRoles');
          commit(admin.con.ADMIN_LOADING_DONE);
          commit(admin.con.LOADING_DONE, null, { root: true });
        } catch (error) {
          commit(admin.con.ADMIN_LOADING_ERROR, error);
          commit(admin.con.LOADING_DONE, null, { root: true });
        }
      }
    ),
    getSearchedUsers: firestoreAction(
      async ({ bindFirestoreRef, commit, dispatch }, kw) => {
        commit(admin.con.LOADING_INIT, null, { root: true });
        commit(admin.con.ADMIN_LOADING_INIT);
        try {
          const collection = db.collection('users');
          const ref = startsWithQuery(collection, 'email', kw);
          await bindFirestoreRef('users', ref, kw);
          await dispatch('getRoles');
          commit(admin.con.ADMIN_LOADING_DONE);
          commit(admin.con.LOADING_DONE, null, { root: true });
        } catch (error) {
          commit(admin.con.ADMIN_LOADING_ERROR, error);
          commit(admin.con.LOADING_DONE, null, { root: true });
        }
      }
    )
  }
});

export default canUpdate()(admin);
